import React from 'react';

export const VerticalDivider: React.FC = () => {
  return <hr style={{ width: '1px', height: '30px', color: '#e6e6e6' }} />;
};
